/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, November 2020
 */

import { useTheme as defaultUseTheme } from '@emotion/react';
import { Theme } from './theme';

export default function useTheme(): Theme {
  return defaultUseTheme() as Theme;
}
